import React from "react";

import Tabs from "@arachnys/styleguide/Tabs";
import NarrativeTable from "./NarrativeTable";
import DispositionTable from "./DispositionTable";

const BISProcessHistory = props => {
    const tabs = [
        {
            label: "Narrative",
            key: "narrative",
            content: (
                <NarrativeTable
                    processRelayId={props.processRelayId}
                    schema={props.schema}
                />
            ),
        },
        {
            label: "Full Results",
            key: "fullResults",
            content: <DispositionTable processRelayId={props.processRelayId} />,
        },
    ];

    return <Tabs defaultActiveKey="narrative" tabs={tabs} />;
};

export default BISProcessHistory;
